import { useEffect, useRef } from 'react';

const scroll = (parent, accessor, index, smooth) => {
  const element = accessor(parent, index);
  element && element.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto' });
};

/**
 * A hook to execute scroll into particular list element
 * @param index the index of element on a list. When it changes, a scrolling occurs so element of that index is ont the top of scrolling container
 * @param accessor the function that returns DOM of a list element on given index
 * @returns {{ref: *}} a reference that has to be provided to the scrolling container Virtual Element
 */
export const useScrollToElement = (index, accessor) => {
  const ref = useRef(null);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (ref.current) {
      scroll(ref.current, accessor, index, !firstUpdate.current);
    }
    firstUpdate.current = false;
  }, [index, accessor]);

  return { ref };
};
